import axios from 'axios';

import { empty } from '../../js/util/util-functions';

/**
 * Class ApiClient.
 */
export default class ApiClient {
  constructor() {
    this.client = axios.create();
  }

  /**
   * @param cancellationId
   * @returns {Promise<AxiosResponse<any>>}
   */
  async getSubCancellations(cancellationId) {
    return this.client.get('/public/api/cancellation', { params: { id: cancellationId } });
  }

  /**
   * @param id
   * @param limit
   * @param offset
   * @returns {Promise<AxiosResponse<any>>}
   */
  async getCancellationReviews(id, limit, offset) {
    if (true === empty(id)) {
      throw new TypeError('id must be defined to get cancellation reviews');
    }
    return this.client.get(
      `/public/api/cancellation/${id}/reviews`,
      { params: { limit, offset } },
    );
  }

  /**
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async submitCancellationReview(id, payload) {
    if (true === empty(id)) {
      throw new TypeError('id must be defined to submit a review');
    }
    return this.client.post(`/public/api/cancellation/${id}/reviews`, payload);
  }

  async submitAnonymousReview(id, payload) {
    if (true === empty(id)) {
      throw new TypeError('id must be defined to submit an anonymous cancellation');
    }
    return this.client.post(`/public/api/cancellation/${id}/reviews-anonymous`, payload);
  }

  /**
   * This method must maintain the same calling signature as downloadPdf.
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async postForm(id, payload) {
    if (true === empty(id)) {
      return this.client.post('/public/api/cancellations/order', payload);
    }

    return this.client.post(`/public/api/cancellations/order/${id}`, payload);
  }

  /**
   * This method must maintain the same calling signature as postForm.
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async downloadPdf(id, payload) {
    if (true === empty(id)) {
      return this.client.post('/public/api/cancellations/pdf', payload);
    }
    return this.client.post(`/public/api/cancellations/pdf/${id}`, payload);
  }

  async fetchIp() {
    return this.client.get('https://api.ipify.org?format=json');
  }

  async register(payload) {
    return this.client.post('/public/api/v1/register', payload);
  }

  async login(payload) {
    return this.client.post('/public/api/v1/login', payload);
  }

  async updatePassword(password) {
    return this.client.post('/public/api/v1/update-password', { password });
  }

  async callTypeahead(q) {
    return this.client.get('/typeahead', { params: { q } });
  }
}
